import { Assignation, RANKING, STM } from '../../context/types'
import { logException, toStr } from '../../services/sentryLogger'
import { titleCaseWord } from '..'
import { CATS, DEFAULT_CAT_MAP, DIMENSIONS, VALUES } from './cats'
import { Scanning360Params } from '../../parameters/types'
import _ from 'lodash'

// FIXME adjust
export const MAX_LENGTH = 95 // FIXME more? max=66 among stms

// FIXME inside STM.valueKey
export const STM_W_CAT_DIMENSIONS = [
    {
        id: 1,
        category: CATS.SAMEN,
        // TODO use it
        dimension: DIMENSIONS.SOCIAL_VALUE,
    },
    {
        id: 2,
        category: CATS.SAMEN,
        dimension: DIMENSIONS.SOCIAL_VALUE,
    },
    {
        id: 3,
        category: CATS.SAMEN,
        dimension: DIMENSIONS.SOCIAL_VALUE,
    },
    {
        id: 4,
        category: CATS.CONF,
        dimension: DIMENSIONS.CONSERVATIVENESS,
    },
    {
        id: 5,
        category: CATS.CONF,
        dimension: DIMENSIONS.CONSERVATIVENESS,
    },
    {
        id: 6,
        category: CATS.CONF,
        dimension: DIMENSIONS.CONSERVATIVENESS,
    },
    {
        id: 7,
        category: CATS.ERKEN,
        dimension: DIMENSIONS.RECOGNITION,
    },
    {
        id: 8,
        category: CATS.ERKEN,
        dimension: DIMENSIONS.RECOGNITION,
    },
    {
        id: 9,
        category: CATS.ERKEN,
        dimension: DIMENSIONS.RECOGNITION,
    },
    {
        id: 10,
        category: CATS.ZORG,
        dimension: DIMENSIONS.SOCIAL_VALUE,
    },
    {
        id: 11,
        category: CATS.ZORG,
        dimension: DIMENSIONS.SOCIAL_VALUE,
    },
    {
        id: 12,
        category: CATS.ZORG,
        dimension: DIMENSIONS.SOCIAL_VALUE,
    },
    {
        id: 13,
        category: CATS.GELIJK,
        dimension: DIMENSIONS.SOCIAL_VALUE,
    },
    {
        id: 14,
        category: CATS.GELIJK,
        dimension: DIMENSIONS.SOCIAL_VALUE,
    },
    {
        id: 15,
        category: CATS.GELIJK,
        dimension: DIMENSIONS.SOCIAL_VALUE,
    },
    {
        id: 16,
        category: CATS.ZELFSTURING,
        dimension: DIMENSIONS.GROWTH_FLEXIBILITY,
    },
    {
        id: 17,
        category: CATS.ZELFSTURING,
        dimension: DIMENSIONS.GROWTH_FLEXIBILITY,
    },
    {
        id: 18,
        category: CATS.ZELFSTURING,
        dimension: DIMENSIONS.GROWTH_FLEXIBILITY,
    },
    {
        id: 19,
        category: CATS.MACHT,
        dimension: DIMENSIONS.POWER,
    },
    {
        id: 20,
        category: CATS.MACHT,
        dimension: DIMENSIONS.POWER,
    },
    {
        id: 21,
        category: CATS.MACHT,
        dimension: DIMENSIONS.POWER,
    },
    {
        id: 22,
        category: CATS.VOORSPELBAAR,
        dimension: DIMENSIONS.CONSERVATIVENESS,
    },
    {
        id: 23,
        category: CATS.VOORSPELBAAR,
        dimension: DIMENSIONS.CONSERVATIVENESS,
    },
    {
        id: 24,
        category: CATS.VOORSPELBAAR,
        dimension: DIMENSIONS.CONSERVATIVENESS,
    },
    {
        id: 25,
        category: CATS.PRESTATIE,
        dimension: DIMENSIONS.RECOGNITION,
    },
    {
        id: 26,
        category: CATS.PRESTATIE,
        dimension: DIMENSIONS.RECOGNITION,
    },
    {
        id: 27,
        category: CATS.PRESTATIE,
        dimension: DIMENSIONS.RECOGNITION,
    },
    {
        id: 28,
        category: CATS.ZELFONTPLOOI,
        dimension: DIMENSIONS.GROWTH_FLEXIBILITY,
    },
    {
        id: 29,
        category: CATS.ZELFONTPLOOI,
        dimension: DIMENSIONS.GROWTH_FLEXIBILITY,
    },
    {
        id: 30,
        category: CATS.ZELFONTPLOOI,
        dimension: DIMENSIONS.GROWTH_FLEXIBILITY,
    },
    {
        id: 31,
        category: CATS.DUURZAAM,
        dimension: DIMENSIONS.QUALITY,
    },
    {
        id: 32,
        category: CATS.DUURZAAM,
        dimension: DIMENSIONS.QUALITY,
    },
    {
        id: 33,
        category: CATS.DUURZAAM,
        dimension: DIMENSIONS.QUALITY,
    },
    {
        id: 34,
        category: CATS.INTEGRITEIT,
        dimension: DIMENSIONS.QUALITY,
    },
    {
        id: 35,
        category: CATS.INTEGRITEIT,
        dimension: DIMENSIONS.QUALITY,
    },
    {
        id: 36,
        category: CATS.INTEGRITEIT,
        dimension: DIMENSIONS.QUALITY,
    },
    {
        id: 37,
        category: CATS.INNOVATIE,
        dimension: DIMENSIONS.GROWTH_FLEXIBILITY,
    },
    {
        id: 38,
        category: CATS.INNOVATIE,
        dimension: DIMENSIONS.GROWTH_FLEXIBILITY,
    },
    {
        id: 39,
        category: CATS.INNOVATIE,
        dimension: DIMENSIONS.GROWTH_FLEXIBILITY,
    },
    {
        id: 40,
        category: CATS.DAADKRACHT,
        dimension: DIMENSIONS.QUALITY,
    },
    {
        id: 41,
        category: CATS.DAADKRACHT,
        dimension: DIMENSIONS.QUALITY,
    },
    {
        id: 42,
        category: CATS.DAADKRACHT,
        dimension: DIMENSIONS.QUALITY,
    },
    // FIXME refactor
    {
        id: 43,
        category: CATS.DAADKRACHT,
        dimension: DIMENSIONS.QUALITY, //FIXME
    },
    {
        id: 44,
        category: CATS.GELIJK,
        dimension: DIMENSIONS.SOCIAL_VALUE,
    },
    {
        id: 45,
        category: CATS.PRESTATIE,
        dimension: DIMENSIONS.RECOGNITION,
    },
] as const

function getTitle360(
    s: Omit<STM, 'title'> & { title?: string },
    params360: Scanning360Params
) {
    let title360 = ''
    let preferredType360 = s.preferredType
    if (params360?.is360 && preferredType360 !== 'disabled') {
        if (params360?.is360WithLeadership && params360?.is360WithWorkenv) {
            // mixte
            title360 +=
                s?.[
                    `title_360_${preferredType360}` as
                        | 'title_360_leadership'
                        | 'title_360_workenv'
                ]
        } else if (params360?.is360WithLeadership) {
            // only leadership
            title360 += s.title_360_leadership
            preferredType360 = s.title_360_leadership
                ? 'leadership'
                : 'disabled'
        } else if (params360?.is360WithWorkenv) {
            // only workenv
            title360 += s.title_360_workenv
            preferredType360 = s.title_360_workenv ? 'workenv' : 'disabled'
        } else {
            // This case should not happen, but in the lack of parameters, we fallback to mixte
            // preferredType360 = 'disabled'
            // MIXTE by fallback:
            logException('getTitle360', 'No mixte or single type for 360 preferredType')
            title360 +=
                s?.[
                    `title_360_${preferredType360}` as
                        | 'title_360_leadership'
                        | 'title_360_workenv'
                ]
        }
    }
    return { title360, preferredType360 }
}

export const stm2Asgn = (params360: Scanning360Params) => {
    const catMap: typeof DEFAULT_CAT_MAP = { ...DEFAULT_CAT_MAP }
    return (s: Omit<STM, 'title'> & { title?: string }, i: number) => {
        const {
            category,
            dimension,
        } = STM_W_CAT_DIMENSIONS.find((c) => c.id === s.id) ?? {}
        if (!category) {
            logException('no category found for stm', toStr(s))
            throw new Error('no category found for stm' + toStr(s))
        }
        const { title360, preferredType360 } = getTitle360(s, params360)
        return {
            ..._.omit(s, 'preferredType', 'title_360_workenv', 'title_360_leadership'),
            index: i, // FIXME
            id: String(s.id), // == String(i + 1),
            ranking: -1 as RANKING, // FIXME
            weight: 0,
            roundNumber: -1,
            category,
            valueKey: s.valueKey ?? `${category.toLowerCase()}${++catMap[
                category //FIXME broken for samen4
            ]}` as VALUES,
            title: (params360.is360
                ? title360
                : titleCaseWord(s.title ?? '')
            ).substring(0, MAX_LENGTH),
            preferredType360,
            dimensionKey: dimension,
        } as Assignation
    }
}
